import '../sentry.config';

import React from 'react';
import ReactDOM from 'react-dom/client';
import '../fontAwesome.config';
import { App } from './App';
import './main.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root Element Missing');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
